import './main.css';
import { Link } from 'react-router-dom';
import { useNavigate } from "react-router-dom";
import { useEffect, useState } from 'react';
import Sider from "../../comps/sider/main";
import { Popconfirm , Alert, Skeleton, Card, message, Col, Row, Statistic, Tooltip, Empty, Button, Collapse, Popover, Divider, Modal, Segmented, Tag, Drawer, Space, Input, Upload } from "antd";
import { CopyTwoTone, EditTwoTone, UploadOutlined, EyeOutlined, SendOutlined, CommentOutlined , LinkOutlined, DeleteOutlined } from '@ant-design/icons';
import { EditText, EditTextarea } from 'react-edit-text';
import callAPI from "../../comps/fetch/main";

function YT() {


    const navigate = useNavigate();
    const [messageApi, contextHolder] = message.useMessage();



    const [joinWaitlist, setJoinWaitList] = useState()

    const [waitlistJoined, setWaitListJoined] = useState(localStorage.getItem("yt-intrested"))

    

    useEffect(() => {
        if(waitlistJoined == undefined){
            return
        }
    },[waitlistJoined])
    

    useEffect(() => {

        if (joinWaitlist == undefined){
            return
        }

        let user_detail =  JSON.parse(localStorage.getItem("userData"))
        let igid =  localStorage.getItem("ig_id")

        const BOT_TOKEN = "7109212238:AAEsaFubA66rs0Ib6rgn5K2amKO9rnOkUv0";
        const CHAT_ID = '776956029';
        const url = `https://api.telegram.org/bot${BOT_TOKEN}/sendMessage`;
        let tele_message = `[YT Intrested] - user ${user_detail.emailid} = user id = ${user_detail.user_id}`
        let data = {
            chat_id: CHAT_ID,
            text: tele_message
        };


        fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(data)
        })
        .then(response => response.json())
        .then(data => {
            console.log('Message sent successfully:', data);
            setWaitListJoined(true)
            localStorage.setItem("yt-intrested", true)
        })
        .catch(error => {
            console.error('Error sending message:', error);
        });


    } , [joinWaitlist])




    return (
        <div className="page-layout">
            {contextHolder}

            <Sider />
            
            <div className="yt-page-content">
                <div className='yt-intro'>
                <h1>Auto Post your IG reels as YT Shorts  <Tag color="purple" style={{marginLeft:'10px' , fontSize:'14px' , fontWeight:'normal'}}>Coming Soon</Tag> </h1>
                <p>What if you could upload a reel to Instagram and we automatically post it to YouTube Shorts in your Youtube channel, and you can make money without any work? 🤔💻 Interested? Join our waitlist! 📈</p>
               { waitlistJoined != undefined ?
               
               <div className='create-btn'>
                    Thanks, will notify you!
                </div>
                :  <div className='create-btn' onClick={() => { setJoinWaitList(true) }}>
                    Join waitlist 🎉
                </div>
}
                </div>

            </div>


            

        </div>
    )

}

export default YT;
